export const defaultInternProgressTrackerSearchParams = () => {
  return InternProgressTrackerSearchParamsModel.fromJS({
    advisorUsers: [],
    primaryOnly: true,
    opportunityStatus: [],
    opportunitySeasonNumber: undefined,
    opportunitySeasonYear: undefined,
    isUniversityProgram: false,
    isPreUniversity: false,
  })
}

export class InternProgressTrackerSearchParamsModel implements IInternProgressTrackerSearchParamsModel {
  advisorUsers?: string[] | undefined;
  primaryOnly?: boolean | undefined;
  opportunityStatus?: string[] | undefined;
  opportunitySeasonNumber?: number | undefined;
  opportunitySeasonYear?: number | undefined;
  isUniversityProgram?: boolean | undefined;
  isPreUniversity?: boolean | undefined;

  constructor(data?: IInternProgressTrackerSearchParamsModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      if (Array.isArray(Data["advisorUsers"])) {
        this.advisorUsers = [] as any;
        for (let item of Data["advisorUsers"])
          this.advisorUsers!.push(item);
      }
      this.primaryOnly = Data["primaryOnly"];
      if (Array.isArray(Data["opportunityStatus"])) {
        this.opportunityStatus = [] as any;
        for (let item of Data["opportunityStatus"])
          this.opportunityStatus!.push(item);
      }
      this.opportunitySeasonNumber = Data["opportunitySeasonNumber"];
      this.opportunitySeasonYear = Data["opportunitySeasonYear"];
      this.isUniversityProgram = Data["isUniversityProgram"];
      this.isPreUniversity = Data["isPreUniversity"];
    }
  }

  static fromJS(data: any): InternProgressTrackerSearchParamsModel {
    data = typeof data === 'object' ? data : {};
    let result = new InternProgressTrackerSearchParamsModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.advisorUsers)) {
      data["advisorUsers"] = [];
      for (let item of this.advisorUsers)
        data["advisorUsers"].push(item);
    }
    data["primaryOnly"] = this.primaryOnly;
    if (Array.isArray(this.opportunityStatus)) {
      data["opportunityStatus"] = [];
      for (let item of this.opportunityStatus)
        data["opportunityStatus"].push(item);
    }
    data["opportunitySeasonNumber"] = this.opportunitySeasonNumber;
    data["opportunitySeasonYear"] = this.opportunitySeasonYear;
    data["isUniversityProgram"] = this.isUniversityProgram;
    data["isPreUniversity"] = this.isPreUniversity;
    return data;
  }
}

export interface IInternProgressTrackerSearchParamsModel {
  advisorUsers?: string[] | undefined;
  primaryOnly?: boolean | undefined;
  opportunityStatus?: string[] | undefined;
  opportunitySeasonNumber?: number | undefined;
  opportunitySeasonYear?: number | undefined;
  isUniversityProgram?: boolean | undefined;
  isPreUniversity?: boolean | undefined;
}